import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Radio, Select } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import { InputBox } from "../../../components/CustomWidgets/InputBox";
import { useFormik } from "formik";
import SelectBox, {
  MultiSelectBox,
} from "../../../components/CustomWidgets/SelectBox";
import { Image } from "antd";
// import Group from "../../assets/Inventory/Group.svg";
import {
  InventoryProductRequest,
  fetchGS1,
  getInventoryEditResttriction,
  getUOM,
  updateGsProductRequest,
  uploadImage,
  uploadImageUrl,
} from "../../../API  Functions/InventoryFunctions";
import "../../../styles.css";
import UploadMediaonly from "../../../components/upload-imageonly";
import ProductrequestModal from "../../../modals/ProductrequestModal";
import { productRequestSchema } from "../../../components/validationSchema";
import Navbar from "../../../components/Navbar/Navbar";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading";
import { checkPermission } from "../../../Utils/permissionHelper";
import { toast } from "react-toastify";
import { GetRetailerDetails } from "../../../API  Functions/ProfileFunctions";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { getProductGroups } from "../../../API  Functions/productGroupFunctions";

const ProductRequestModal = ({updateScreen, fetchedProduct, onCancel }) => {
   const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const location = useLocation();
  const userData = useSelector((state) => state?.login?.user?.result);

  const [UOM, setUOM] = useState([]);
  const [isUOMLoaded, setIsUOMLoaded] = useState(false);
  const [popup, setpopup] = useState(false);
  const [isnew, setisnew] = useState(false);
  const [isGS1, setisGS1] = useState(false);
  const [data, setdata] = useState([]);
  const [searchid, setsearchid] = useState("");
  const [base64Image, setBase64Images] = useState("");
  const [isFileValid, setIsFileValid] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [vatTypes, setVatTypes] = useState([]);
  const [taxId, setTaxId] = useState("");
    const [isEtaEnable, setIsEtaEnable] = useState(null);
  
  const EGS_PREFIX = `EG-${taxId}-`;
  const navigate = useNavigate();

  useEffect(() => {
    console.log("isFileValid ", isFileValid);

    if (base64Image && isFileValid === false) {
      // getInventoryKPI();
      setBase64Images("");
      formik.setFieldValue("image_url", "");
    }
  }, [isFileValid, base64Image]);

  useEffect(() => {
    fetchdetails();
    // GetGroups();
    // GetVatTypes();
    // CheckUserAcessForInventory();
  }, []);

     const CheckUserAcessForInventory = async () => {
        try {
          const res = await getInventoryEditResttriction(user_id);
          if (res?.result?.status_code == 200) {
            setIsEtaEnable(res?.result?.is_eta_enabled);
          }
        } catch (error) {
          console.log(error);
        } finally {
        }
      };


    const GetVatTypes = async () => {
      const payload = {
        retailer_id: store_id,
        offset: 0,
        limit: 1000,
      };
      try {
        const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
        const res1 = res?.data;
  
        // console.log("res1---->", res1);
  
        if (res1?.result?.status_code === 200) {
            setVatTypes(res1?.result?.data?.filter(item => item.is_active));
        } else {
          setVatTypes([]);
        }
      } catch (error) {
        console.error("Error fetching KPI data:", error);
        // setloading(false);
      } finally {
        // setloading(false);
      }
    };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setTaxId(
          result?.retailer_details?.tax_card_number
            ? result?.retailer_details?.tax_card_number
            : null,
        );
      }
    });
  };

  const GetGroups = async () => {
    const payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: store_id,
      user_id: user_id,
      offset: 0,
      limit: 5000,
    };
    try {
      const res1 = await getProductGroups(payload);

      // console.log("res1---->", res1);

      if (res1?.result[0]?.status_code === 200) {
        setAllGroups(res1?.result[0]?.product_groups);
      } else {
        setAllGroups([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const get_UOM = async () => {
    const res = await getUOM();

    if (res?.result?.[0].status == "UOM List")
      setUOM(res?.result?.[0]?.uom_list);
    setIsUOMLoaded(true);
  };

  const checkSecondaryBarcode = async (
    product_id,
    secondaryBarcode,
    company_id,
  ) => {
    try {
      const body = {
        product_id: product_id, // if new product, send 0
        barcode: secondaryBarcode,
        company_id,
      };

      const res = await axiosInstance.post("/Store/2/CheckBarcode", body);

      return res?.data;
      // Example expected: "Barcode already exists" or "Barcode available"
    } catch (error) {
      console.error("Error checking barcode:", error);
      return "error";
    }
  };

  const Productrequest = async (val) => {
    if (!val?.name) return;

    setProcessing(true);

    // ✅ HARD STOP for secondary barcode validation
    if (val?.secondaryBarcode?.trim()) {
      const result = await checkSecondaryBarcode(
        false,
        val.secondaryBarcode,
        store_id,
      );

      console.log("result====>", result);

      if (result?.result?.status_code !== 200) {
        toast.error(t(result?.result?.status));
        setProcessing(false);
        return false; // ⛔ NOTHING after this will run
      }
    }

    // ✅ EVERYTHING below runs ONLY if barcode is valid
    const costPrice = val?.costprice || 0;
    const salePrice = val?.saleprice || 0;
    const discountedPrice = val?.discounted_price || 0;

    const verifyEgsCodeAPI = async (egsCode, prod_id) => {
      try {
        const body = {
          product_id: prod_id || 0, // if new product, send 0
          egs_code: egsCode,
          company_id: store_id,
        };

        const res = await axiosInstance.post(URLS.VERIFY_EGS_CODE, body);

        if (res?.data?.result?.status_code == 200) {
          // AddProductEGSCode(egsCode, prod_id);
        } else {
          toast.error(t("EGS code not verified"));
        }
      } catch (error) {
        console.error("Error checking barcode:", error);
        // return "error";
      }
    };

    const AddProductEGSCode = async (egsCode, prodId) => {
      try {
        const payload = {
          egs_code: egsCode,
          company_id: store_id,
          product_id: prodId, // <-- add product_id
        };
        const response = await axiosInstance.post(URLS.ADD_PRODUCT, payload);
      } catch (error) {
        console.error("Error checking barcode:", error);
        // return "error";
      }
    };
   let updatedVal = { ...val };

if (updatedVal?.barcode?.trim() !== "" && !updatedVal?.is_gs1) {
  const fetchGtinResponse = await axiosInstance.post(
    "/fetch_gs1_data",
    {
      gtin: updatedVal.barcode.trim(),
    }
  );

  if (fetchGtinResponse.data?.result?.gtin) {
    const resp = fetchGtinResponse.data.result;

    updatedVal.is_gs1 = true;

 if (!updatedVal.custom_name || updatedVal.custom_name.trim() === "") {
      updatedVal.custom_name = updatedVal.name;
    }

    updatedVal.name =
      i18n.language === "ar"
        ? resp.product_description_arabic || resp.product_description_english 
        : resp.product_description_english || resp.product_description_english;
  
  }
}

    const isValidEgsFilled = (egs) => {
      if (!egs) return false;
      if (egs === EGS_PREFIX) return false;
      return egs.length > EGS_PREFIX.length;
    };

    const response = await InventoryProductRequest(
      user_id,
      updatedVal,
      costPrice,
      salePrice,
      discountedPrice,
    );

    if (
      response?.result?.[0]?.status_code === 400 &&
      response?.result?.[0]?.status ===
        "Entered short code is already linked with another product."
    ) {
      toast.error(
        t(
          "Product Short Code Already Exists. Please Use a Different Short Code.",
        ),
      );
      setProcessing(false);
      return false;
    }

    if (response?.result?.[0]?.status_code === 200) {
      const productId = response.result[0].product_id;

      // const newEgs = val.egs_code;
      // const hasEgsNow = isValidEgsFilled(newEgs);

      //   // 👉 EGS entered now but wasn't there before
      //   if (hasEgsNow && (!userData?.is_sub_store && !userData?.is_warehouse)) {
      //        verifyEgsCodeAPI(newEgs, productId);
      //   }

      if (val?.secondaryBarcode?.trim()) {
        await handleAddSecondaryBarcode(productId, val.secondaryBarcode);
      }

      const uploadedImageUrl = await uploadImage(productId, base64Image);

      if (uploadedImageUrl) {
        formik.setFieldValue("image_url", uploadedImageUrl);
        await uploadImageUrl(productId, uploadedImageUrl);
      }

      const uomName = UOM.find((uom) => uom?.uom_id == updatedVal?.product_uom).uom_name
      setisnew(true);
      setpopup(true);
      formik.resetForm();
      setBase64Images("");
      setProcessing(false);
      updateScreen(
        productId,
        updatedVal,
        costPrice,
      salePrice,
      uomName
    );
      return true;
    } else {
      toast.error(t(response?.result?.[0]?.status));
      setProcessing(false);
      return false;
    }

    setProcessing(false);
    return false;
  };

  const handleAddSecondaryBarcode = async (id, code) => {
    const payload = {
      company_id: store_id,
      product_id: id,
      barcode_data: [
        // NEW BARCODE
        {
          id: false,
          is_delete: false,
          barcode: code,
        },
      ],
    };
    try {
      const response = await axiosInstance.post(
        URLS.ADD_SECONDARY_BARCODE,
        payload,
      );

      if (response?.data?.result?.status_code != 200) {
        toast.error(response?.data?.result?.status);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    UOM?.length == 0 && get_UOM();
  }, []);


  const formik = useFormik({
    initialValues: {
      name: fetchedProduct?.product_description_english || "",
      custom_name: "",
      // egs_code:"",
      barcode: fetchedProduct?.gtin || "",
      product_uom: "",
      costprice: "",
      saleprice: "",
      discounted_price: "",
      quantity: "",
      image_url: "",
      product_code: "",
      productShortcut: "",
      secondaryBarcode: "",
      groups: [],
      is_gs1: fetchedProduct?.gtin ? true : false,
      isinclusive:null,
      tax_id:null
    },
    validationSchema: productRequestSchema,
  });

  useEffect(() => {
    if (isUOMLoaded && fetchedProduct?.gtin) {
      const uomId = UOM.find((uom) => uom.uom_name === "Units")?.uom_id;
      if (uomId) {
        formik.setFieldValue("product_uom", uomId);
      }
    }
  }, [isUOMLoaded, fetchedProduct, UOM]);

  const validate = (values) => {
    const errors = {};
    if (!values.product_uom) {
      errors.product_uom = "Product UOM is required";
    }
    console.log();
    const isLoose =
      formik.values.product_uom &&
      UOM.find(
        (uom) =>
          (uom.uom_name === "KG" ||
            uom.uom_name === "Kg" ||
            uom.uom_name === "Liter" ||
            uom.uom_name === "Meter") &&
          uom.uom_id === formik.values.product_uom,
      );

    if (
      isLoose &&
      values.product_code != "" &&
      values.product_code?.length < 7
    ) {
      errors.product_code = "Product Code should have at least 7 digits";
    }

    // Get the selected UOM correctly using values.product_uom
    const selectedUOM = UOM.find((uom) => uom.uom_id === values.product_uom);

    // ✅ Barcode validation — required unless UOM is "Bundle"
    // if (
    //   selectedUOM &&
    //   selectedUOM.uom_name !== "Bundle" &&
    //   (!values.barcode || values.barcode.trim() === "")
    // ) {
    //   errors.barcode = "Barcode is required";
    // }

    if (
      values.costprice &&
      values.saleprice &&
      Number(values.costprice) > Number(values.saleprice)
    ) {
      errors.costprice = t("Cost Price cannot be greater than Sale Price");
    }
    if (
      values.discounted_price &&
      values.saleprice &&
      values.discounted_price > values.saleprice
    ) {
      errors.discounted_price = t(
        "Discounted Price cannot be greater than Sale Price",
      );
    }
    return errors;
  };

  return (
    <>
{processing && <LoadingSpinner />}
      <div className="fixed top-0 left-0 flex flex-col z-30 w-full h-full  items-center backdrop-blur-md drop-shadow-sm  justify-center mx-auto">
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
        <section
          className={` flex flex-col text-lg font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 max-md:px-5 z-50 relative`}
          style={{
            width: "1300px",
          }}
        >
          <button
            type="button"
            onClick={onCancel}
            className={`absolute top-4 ${
              i18n.language === "ar" ? "left-3" : "right-3"
            } text-zinc-800 bg-transparent`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-8 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="h-16 bg-[#C9ECF7] rounded-t-2xl flex items-center">
            <p className="ms-10 font-semibold text-xl">
              {t("Product Request")}
            </p>
          </div>
          <form onSubmit={formik.handleSubmit}>
           <div className="flex flex-row flex-1  bg-white mx-2 border rounded-b-xl">
              <div className="m-2 w-2/4 p-4 ">
                <span className=" block leading-[0px]">
                  {/* <label>{t("product_name")}</label> */}
                  <div className="">
                    <InputBox
                      name="name"
                      label={t("product_name")}
                      placeholder={t("enter_product_name")}
                      // onChange={formik.handleChange}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only alphanumeric characters and spaces
                        // if (/^[a-zA-Z0-9\s]*$/.test(value) || value === "") {
                        formik.setFieldValue("name", value);
                        // }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      error={formik.errors.name}
                      readOnly={
                        fetchedProduct?.gtin &&
                        fetchedProduct?.product_description_english
                      }
                      touched={formik.touched.name}
                      maxLength={150}
                    />
                  </div>
                </span>
                {!userData?.is_sub_store && !userData?.is_warehouse && (
                  <>
                    <div className="flex">
                      <span className=" block leading-[0px] w-6/12 me-3">
                        <InputBox
                          name="custom_name"
                          label={t("Custom Product Name")}
                          placeholder={t("Enter Custom Product Name")}
                          onChange={(event) => {
                            const { value } = event.target;

                            formik.setFieldValue("custom_name", value);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.custom_name}
                          // maxLength={150}
                        />
                      </span>
                      <span className="block leading-[0px] w-6/12">
                        <InputBox
                          label={t("Product Short Code")}
                          className={`${
                            formik.errors.productShortcut ? "border-red" : ""
                          }`}
                          name="productShortcut"
                          placeholder={t("Enter Product Short Code")}
                          onChange={(e) => {
                            const val = e.target.value;
                            formik.setFieldValue("productShortcut", val);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.productShortcut}
                          error={formik.errors.productShortcut}
                          touched={formik.errors.productShortcut}
                          readOnly={
                            userData?.is_sub_store || userData?.is_warehouse
                          }
                          maxLength={10}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </span>
                    </div>
                  </>
                )}

                <div className="flex items-end -mt-2">
                  <span
                    className={`block leading-[0px] w-6/12  mt-2 ${
                      !userData?.is_sub_store && !userData?.is_warehouse
                        ? "w-6/12 me-3"
                        : "w-full"
                    }`}
                  >
                    {/* <label>{t("barcode")}</label> */}
                    <InputBox
                      type="text"
                      name="barcode"
                      label={t("barcode")}
                      placeholder={t("barcode")}
                      maxLength={14}
                      // onChange={formik.handleChange}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only numeric input
                        // if (/^\d*$/.test(value)) { // This regex allows only digits
                        //   formik.setFieldValue("barcode", value);
                        // }
                        if (/^\d*$/.test(value)) {
                          // This regex allows only digits
                          formik.setFieldValue("barcode", value);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.barcode}
                      error={formik.errors.barcode}
                      touched={formik.touched.barcode}
                      readOnly={!!fetchedProduct?.gtin}
                    />
                  </span>
                  {!userData?.is_sub_store && !userData?.is_warehouse && (
                    <span className="block leading-[0px] w-6/12">
                      <InputBox
                        label={t("Secondary Barcode")}
                        type="number"
                        className={`${
                          formik.errors.secondaryBarcode ? "border-red" : ""
                        }`}
                        name="secondaryBarcode"
                        placeholder={t("Enter Secondary Barcode")}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d{0,18}$/.test(val)) {
                            formik.setFieldValue("secondaryBarcode", val);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.secondaryBarcode}
                        error={formik.errors.secondaryBarcode}
                        touched={formik.errors.secondaryBarcode}
                        maxLength={14}
                      />
                    </span>
                  )}
                </div>
                {/* {isEtaEnable == true && <>
                  {!userData?.is_sub_store && !userData?.is_warehouse && (
                  <span className="block leading-[0px] w-full">
                    <InputBox
                      name="egs_code"
                      label={t("EGS Code")}
                      placeholder={t("Enter EGS Code")}
                      value={
                        formik.values.egs_code?.startsWith(EGS_PREFIX)
                          ? formik.values.egs_code
                          : EGS_PREFIX
                      }
                      readOnly={userData?.is_sub_store}
                      maxLength={30}
                      onChange={(event) => {
                        let value = event.target.value;

                        // If user tries to delete prefix, restore it
                        if (!value.startsWith(EGS_PREFIX)) {
                          value = EGS_PREFIX;
                        }

                        // Allow only digits after prefix
                        const suffix = value
                          .slice(EGS_PREFIX.length)
                          .replace(/[^0-9]/g, "");

                        formik.setFieldValue("egs_code", EGS_PREFIX + suffix);
                      }}
                      onKeyDown={(e) => {
                        const cursorPosition = e.target.selectionStart;

                        // Prevent backspace/delete inside prefix
                        if (
                          (e.key === "Backspace" || e.key === "Delete") &&
                          cursorPosition <= EGS_PREFIX.length
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </span>
                )}
                 <div className="mt-3 flex w-full justify-between">
                     <div className="w-1/2 me-7">
                                  <h3 className="text-sm font-normal mb-2 text-gray-600">
                                    {t("Tax")}
                                  </h3>
                                  <Select
                                    style={{ width: "100%" }}
                                    placeholder={t("Select Tax")}
                                    className="h-10"
                                    value={formik.values?.taxId}
                                    onChange={(value) => formik.setFieldValue("taxId", value)}
                                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                    options={vatTypes.map((vat) => ({
                                     label: `${vat.tax_name} (${vat.tax_rate_percent}%)`,
                                      value: vat.id,
                                    }))}
                                  />
                                </div>
                                  <div className="w-1/2 flex flex-col">
              <h3 className="text-sm font-normal mb-2 text-gray-600">
                {t("Tax Type")}
              </h3>

              <Radio.Group
                value={formik.values?.isinclusive == true ? 'inclusive' : formik.values?.isinclusive == false  ? 'exclusive' : null}
                onChange={(e) => formik.setFieldValue("isinclusive", e.target.value == "inclusive" ? true : false)}
              >
                <Radio value="exclusive">{t("Exclusive")}</Radio>
                <Radio value="inclusive">{t("Inclusive")}</Radio>
              </Radio.Group>
            </div>
                  </div></>} */}
              
                {/* {!userData?.is_sub_store &&
                  !userData?.is_warehouse &&
                  !processing && (
                    <div className="mt-3">
                      <MultiSelectBox
                        label={t("Product Groups")}
                        name="groups"
                        onChange={(event) => {
                          formik.setFieldValue("groups", event.target.value);
                        }}
                        placeholder={t("Select Groups")}
                        // defaultValue={selectedGroups?.map((item) => ({
                        //     value: item?.id,
                        //     label: item?.name,
                        //   }))
                        // }
                        options={[
                          ...allGroups?.map((item) => ({
                            value: item?.id,
                            label:
                              i18n.language == "ar"
                                ? item?.name_ar
                                : item?.name,
                          })),
                        ]}
                      />
                    </div>
                  )} */}
                <div className="flex flex-row gap-5">
                  <span className="w-full leading-[0px]">
                    {/* <label>{t("quantity")}</label> */}
                    <InputBox
                      type="text"
                      name="quantity"
                      label={t("quantity")}
                      placeholder={t("enter_quantity")}
                      // onChange={formik.handleChange}
                      // onChange={(event) => {
                      //   const { value } = event.target;

                      //   // Allow only numbers and restrict to 7 digits
                      //   if (/^\d{0,5}$/.test(value)) {
                      //     formik.setFieldValue("quantity", value);
                      //   }
                      // }}

                      onChange={(event) => {
                        const { value } = event.target;

                        const selectedUom = UOM.find(
                          (uom) =>
                            uom.uom_name === "Units" &&
                            uom.uom_id === formik.values.product_uom,
                        );
                        // {console.log("KKKK",selectedUom?.name)}

                        // Allow only valid input based on UOM
                        if (
                          (selectedUom?.uom_name !== "Units" &&
                            /^\d*\.?\d{0,2}$/.test(value)) || // Allow decimals for non-units
                          (selectedUom?.uom_name === "Units" &&
                            /^\d{0,6}$/.test(value)) // Only whole numbers for units
                        ) {
                          // Prevent multiple hyphens and other invalid characters
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("quantity", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.quantity}
                      error={formik.errors.name}
                      touched={formik.touched.name}
                    />
                  </span>
                  <span className="w-full leading-[0px] flex flex-col">
                    {/* <label className="pb-2">{t("product_uom")}</label> */}
                    <SelectBox
                      name="product_uom"
                      label={t("product_uom")}
                      defaultValue=""
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.product_uom}
                      options={[
                        { value: "", label: t("select"), disabled: true },
                        ...UOM?.map((item) => ({
                          value: item.uom_id,
                          label: t(item.uom_name),
                        })),
                      ]}
                      error={formik.errors.product_uom}
                      touched={formik.touched.product_uom}
                      disabled={!!fetchedProduct?.gtin}
                    />
                  </span>
                </div>

                {formik.values.product_uom &&
                  UOM.find(
                    (uom) =>
                      (uom.uom_name === "KG" ||
                        uom.uom_name === "Kg" ||
                        uom.uom_name === "Liter" ||
                        uom.uom_name == "Meter") &&
                      uom.uom_id === formik.values.product_uom,
                  ) && (
                    <div className=" w-full leading-[0px]">
                      {/* <label>{t("Product Code")}</label> */}
                      <InputBox
                        label={t("Weighing Scale Product Code")}
                        type="number"
                        name="product_code"
                        placeholder={t("Enter Product Code")}
                        // onChange={formik.handleChange}
                        onChange={(event) => {
                          const { value } = event.target;

                          // Allow only numbers and restrict to 7 digits
                          if (/^\d{0,7}$/.test(value)) {
                            formik.setFieldValue("product_code", value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.product_code}
                        error={formik.errors.product_code}
                        touched={formik.touched.product_code}
                      />
                    </div>
                  )}
                <div className="flex flex-row">
                  <span className=" leading-[0px] w-6/12 me-3">
                    {/* <label>{t("cost_price")}</label> */}
                    <InputBox
                      type="text"
                      label={t("cost_price")}
                      name="costprice"
                      placeholder={t("enter_cost_price")}
                      onChange={(event) => {
                        const { value } = event.target;
                        if (
                          value === "" ||
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value)
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("costprice", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.costprice}
                      error={formik.errors.costprice}
                      touched={formik.touched.costprice}
                    />
                  </span>
                  <span className="leading-[0px] w-6/12">
                    {/* <label>{t("sale_price")}</label> */}
                    <InputBox
                      type="text"
                      label={t("sale_price")}
                      name="saleprice"
                      placeholder={t("enter_sale_price")}
                      onChange={(event) => {
                        const { value } = event.target;

                        if (
                          value === "" || // Allow empty input
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) // Allow numbers with up to 6 digits before decimal and 2 after
                        ) {
                          // Prevent multiple hyphens and other invalid characters
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("saleprice", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.saleprice}
                      error={formik.errors.saleprice}
                      touched={formik.touched.saleprice}
                    />
                  </span>
                  {/* <span className="inline-block leading-[0px]">
                    <InputBox
                      label={t("Discounted Price")}
                      name="discounted_price"
                      type="text"
                     
                      placeholder={t("Enter Discounted Price")}
                      onChange={(event) => {
                        const { value } = event.target;

                        if (
                          value === "" || 
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) 
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("discounted_price", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.discounted_price}
                      error={formik.errors.discounted_price}

                      touched={formik.errors.discounted_price}
                    />
                  </span> */}
                </div>

                <button
                  type="submit"
                  onClick={async () => {
                    if (!checkPermission("/inventory")) {
                      return;
                    }
                    const errors = validate(formik.values);
                    formik.setErrors(errors);
                    console.log("errorserrorserrors", errors);

                    if (Object.keys(errors).length === 0) {
                      const costPrice = formik.values.costprice || 0;
                      const salePrice = formik.values.saleprice || 0;
                      console.log("sahcdshvrevje1113e4343", errors);
                      const check = await Productrequest({
                        ...formik.values,
                        costprice: costPrice,
                        saleprice: salePrice,
                      });

                      if (check) {
                        formik.resetForm();
                      }
                    }
                  }}
                  disabled={
                    !formik.values.name ||
                    !formik.values.product_uom ||
                    // (
                    //   UOM.find(u => u.uom_id === formik.values.product_uom)?.uom_name !== "Bundle" &&
                    //   !formik.values.barcode
                    // ) ||
                    !formik.values.quantity ||
                    (formik.values.costprice && !formik.values.saleprice) || // Disable if cost price is entered but sale price is not
                    (!formik.values.costprice && formik.values.saleprice) ||
                    Number(formik.values.saleprice) <
                      Number(formik.values.costprice) ||
                    // !base64Image ||
                    isFileValid === false ||
                    processing
                  }
                  className={`w-48 h-10 mt-8 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2 ${
                    !formik.values.name ||
                    !formik.values.product_uom ||
                    // (
                    //   UOM.find(u => u.uom_id === formik.values.product_uom)?.uom_name !== "Bundle" &&
                    //   !formik.values.barcode
                    // ) ||
                    !formik.values.quantity ||
                    Number(formik.values.saleprice) <
                      Number(formik.values.costprice) ||
                    (formik.values.costprice && !formik.values.saleprice) ||
                    (!formik.values.costprice && formik.values.saleprice) ||
                    // !base64Image ||
                    isFileValid === false
                      ? "opacity-40"
                      : ""
                  }`}
                  // disabled={!formik.values || !base64Image}
                  // className={`w-48 h-10 mt-8 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2 ${
                  //   !formik.values || !base64Image || isFileValid ? "opacity-40" : ""
                  // }`}
                >
                  <span>{t("save_add")}</span>
                </button>
              </div>
              <div className="m-2 p-4 ">
                <span
                  className={`flex  flex-col w-72 h-80 border rounded-xl relative top-4 ${
                    i18n.language == "en" ? "left-20" : "right-20"
                  } justify-center items-center `}
                >
                  {/* <span
                  className={`flex  flex-col w-72 h-80 border rounded-xl relative top-4 ${i18n.language == "en" ? "left-20" : "right-20"
                    } justify-center items-center ${
                    // formik?.errors?.image_url && formik?.touched?.image_url
                    !formik?.values?.image_url &&
                      !base64Image &&
                      formik?.touched?.image_url
                      ? "border-red"
                      : ""
                    }`}
                > */}
                  {/* {console.log("imageurl", formik?.values?.image_url)} */}
                  {formik?.values?.image_url ? (
                    <img
                      src={formik.values.image_url}
                      height={100}
                      width={100}
                      alt="prod"
                      style={{
                        minWidth: "17rem",
                        maxWidth: "18rem",
                        maxHeight: "13rem",
                        minHeight: "12rem",
                      }}
                    />
                  ) : base64Image ? (
                    <img
                      src={base64Image}
                      height={100}
                      width={100}
                      alt="Uploaded"
                      style={{
                        minWidth: "17rem",
                        maxWidth: "18rem",
                        maxHeight: "13rem",
                        minHeight: "12rem",
                      }}
                    />
                  ) : (
                    <svg
                      className=" float-left h-10 w-12 text-gray-300"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                      />
                    </svg>
                  )}
                  <span className="cursor-pointer">
                    <UploadMediaonly
                      foldername={"store_image"}
                      onfileAdd={"Productrequest"}
                      setBase64Images={setBase64Images}
                      urlgenerated={(val) =>
                        formik.setFieldValue("image_url", val?.url)
                      }
                      imageurl={
                        formik?.values?.image_url == undefined
                          ? ""
                          : formik?.values?.image_url
                      }
                      setIsFileValid={setIsFileValid}
                    />
                  </span>
                </span>
              </div>
            </div>
          </form>
          {popup && (
                  <ProductrequestModal onClose={() => setpopup(false)} isnew={isnew} />
                )}
        </section>
      </div>
    </>
  );
};

export default ProductRequestModal;
